import { CameraSolid } from 'iconoir-react';
import { PhotoButtonProps } from '@usacsmideo/types';

export const TakePhoto = (props: PhotoButtonProps) => {
  return (
    <button onClick={props.setter}>
      <CameraSolid />
    </button>
  );
};
